/**
 * Receipt tax display: avoid duplicate "Tax" total + single-rate breakdown.
 */

/** @param {number|string|null|undefined} rate */
export function formatTaxRatePercent (rate) {
  return Number(rate || 0).toFixed(4).replace(/\.?0+$/, '')
}

/** @param {{ name?: string, rate_percent?: number|string }} row */
export function taxBreakdownRowLabel (row, fallbackName = 'Tax') {
  const pct = formatTaxRatePercent(row?.rate_percent)
  const name = row?.name || fallbackName
  return `${name} (${pct}%)`
}

/** @param {object|null|undefined} sale */
export function getTaxBreakdownFromSale (sale) {
  const rows = sale?.tax_breakdown_json || sale?.tax_breakdown || []
  return Array.isArray(rows) ? rows : []
}

/** @param {object|null|undefined} sale */
export function getSaleTaxAmount (sale) {
  return Number(sale?.tax_amount ?? sale?.tax ?? 0) || 0
}

/**
 * @param {object|null|undefined} sale
 * @param {{ genericTaxLabel?: string }} [options]
 * @returns {Array<{ label: string, amount: number, isDetail?: boolean }>}
 */
export function buildReceiptTaxDisplayLines (sale, options = {}) {
  const genericTaxLabel = options.genericTaxLabel || 'Tax'
  const totalAmount = getSaleTaxAmount(sale)
  const breakdownRows = getTaxBreakdownFromSale(sale)
  const activeRows = breakdownRows.filter((row) => Number(row?.amount || 0) > 0)

  if (totalAmount <= 0 && activeRows.length === 0) {
    return []
  }

  if (activeRows.length === 1) {
    const row = activeRows[0]
    return [{
      label: taxBreakdownRowLabel(row, genericTaxLabel),
      amount: Number(row.amount) || totalAmount
    }]
  }

  if (activeRows.length > 1) {
    return [
      { label: genericTaxLabel, amount: totalAmount },
      ...activeRows.map((row) => ({
        label: taxBreakdownRowLabel(row, genericTaxLabel),
        amount: Number(row.amount) || 0,
        isDetail: true
      }))
    ]
  }

  return [{ label: genericTaxLabel, amount: totalAmount }]
}
